// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N0FJ","col":"styles_col__28fsZ"};